import { render, staticRenderFns } from "./wash.vue?vue&type=template&id=3fb46e17&"
import script from "./wash.vue?vue&type=script&lang=js&"
export * from "./wash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports